import { useMemo } from 'react';
import { consentRoleLabel, isNonSigningSignerType, SIGNER_ROLES } from 'libs.consent.common';
import { useLocalizeMessage } from 'libs.nucleus';
import { useConsentStateContext } from './use_consent_context.hook';
export const useConsentSignerRoles = () => {
    const translate = useLocalizeMessage();
    return useMemo(() => SIGNER_ROLES.map((role) => ({
        value: role.value,
        label: translate(role.label),
    })), [translate]);
};
/**
 * Returns the active document's roles as dropdown options for the signature, initials and data
 * field pickers. A blank Role name falls back to the signer type label so authors can assign
 * fields without prefilling the Roles tab name field.
 *
 * Non-signing participants are left out: they are associated with the document but never sign it,
 * so a field assigned to one could never be completed (SSP-4198, recorded in Classic as EC-1769).
 */
export const useDocumentSignerRoles = () => {
    const { activeDocument } = useConsentStateContext();
    return useMemo(() => (activeDocument?.roles ?? [])
        .filter((r) => !isNonSigningSignerType(r.signerTypeId))
        .map((r) => {
        const label = consentRoleLabel(r);
        return { value: label, label };
    }), [activeDocument?.roles]);
};
